import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { BreakBlock } from '../blocks/BreakBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const BreaksLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { breaks } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {breaks.map((breakModel, index) => (
        <BreakBlock key={index} breakModel={breakModel} index={index} />
      ))}
    </LayerWrapper>
  )
}

export default BreaksLayer
